'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _utils = require('../../utils');

var _nitroIcon = require('../nitro-icon');

var _nitroIcon2 = _interopRequireDefault(_nitroIcon);

var _nitroCheckbox = require('../nitro-checkbox');

var _nitroCheckbox2 = _interopRequireDefault(_nitroCheckbox);

var _styles = require('../nitro-select/styles');

var _styles2 = require('./styles');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NitroMultipleSelect = function (_Component) {
  _inherits(NitroMultipleSelect, _Component);

  function NitroMultipleSelect(props) {
    _classCallCheck(this, NitroMultipleSelect);

    var _this = _possibleConstructorReturn(this, (NitroMultipleSelect.__proto__ || Object.getPrototypeOf(NitroMultipleSelect)).call(this, props));

    _this.handleClickAway = function (e) {
      if (!_this.root.contains(e.target)) {
        _this.setState({
          open: false
        });
      }
    };

    _this.toggleOpen = function (event) {
      event.stopPropagation();
      event.preventDefault();

      _this.setState({
        open: !_this.state.open
      });
    };

    _this.handleOptionSelect = function (checked, value) {
      var values = [].concat(_toConsumableArray(_this.props.value));
      if (checked) {
        values = [].concat(_toConsumableArray(values), [value]);
      } else {
        values = values.filter(function (v) {
          return v !== value;
        });
      }

      if (typeof _this.props.action === 'function') {
        _this.props.action({ value: values });
      }
    };

    _this.state = {
      open: false
    };
    return _this;
  }

  _createClass(NitroMultipleSelect, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      document.addEventListener('click', this.handleClickAway, false);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      document.removeEventListener('click', this.handleClickAway, false);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          className = _props.className,
          containerMaxHeight = _props.containerMaxHeight,
          disabled = _props.disabled,
          options = _props.options,
          placeholder = _props.placeholder,
          value = _props.value;


      var iconName = this.state.open ? 'arrow-up-solid' : 'arrow-down-solid';

      var valueList = value.map(function (v) {
        var selected = options.find(function (option) {
          return option.value === v;
        });
        if (selected) {
          return _react2.default.createElement(
            _styles2.SelectPill,
            { key: 'options-' + selected.value },
            selected.label,
            !_this2.mandatory && _react2.default.createElement(_styles2.SelectPillIcon, {
              name: 'close',
              size: 8,
              left: 6,
              variant: 'white',
              action: function action() {
                return _this2.handleOptionSelect(false, selected.value);
              }
            })
          );
        }
      });

      return _react2.default.createElement(
        _styles.SelectWrapper,
        {
          className: className,
          innerRef: function innerRef(ref) {
            _this2.root = ref;
          }
        },
        _react2.default.createElement(
          _styles.InputContainer,
          { onClick: this.toggleOpen },
          _react2.default.createElement(
            _styles.SelectInput,
            null,
            value.length === 0 ? _react2.default.createElement(
              _styles.Placeholder,
              null,
              placeholder
            ) : _react2.default.createElement(
              _styles2.SelectPillScroller,
              null,
              _react2.default.createElement(
                _styles2.SelectPillWrapper,
                null,
                valueList
              )
            ),
            _react2.default.createElement(
              _styles.InputRight,
              null,
              _react2.default.createElement(_nitroIcon2.default, {
                action: this.toggleOpen,
                name: iconName,
                size: 8,
                variant: 'secondary',
                left: 'auto',
                right: 'auto',
                top: 'auto',
                bottom: 'auto'
              })
            )
          )
        ),
        this.state.open && _react2.default.createElement(
          _styles.ListContainer,
          { maxHeight: containerMaxHeight },
          options.map(function (option) {
            var checked = value.includes(option.value);
            return _react2.default.createElement(
              _styles.ListItem,
              { key: 'item-' + option.value, active: checked },
              _react2.default.createElement(_nitroCheckbox2.default, {
                checked: checked,
                disabled: _this2.mandatory && checked,
                label: option.label,
                action: function action(event, isChecked) {
                  _this2.handleOptionSelect(isChecked, option.value);
                }
              })
            );
          })
        ),
        disabled && _react2.default.createElement(_utils.DisableCover, null)
      );
    }
  }, {
    key: 'mandatory',
    get: function get() {
      var _props2 = this.props,
          mandatory = _props2.mandatory,
          value = _props2.value;

      return mandatory && value.length === 1;
    }
  }]);

  return NitroMultipleSelect;
}(_react.Component);

NitroMultipleSelect.propTypes = {
  action: _propTypes2.default.func,
  className: _propTypes2.default.string,
  containerMaxHeight: _propTypes2.default.string,
  disabled: _propTypes2.default.bool,
  mandatory: _propTypes2.default.bool,
  options: _propTypes2.default.array.isRequired,
  placeholder: _propTypes2.default.string,
  value: _propTypes2.default.array.isRequired
};

NitroMultipleSelect.defaultProps = {
  containerMaxHeight: '200px',
  options: [],
  value: []
};

exports.default = NitroMultipleSelect;


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-multiple-select/NitroMultipleSelect.js
// module id = 3018
// module chunks = 4